export default {
  type: 'pie',
  data: {
    labels: [],
    datasets: [
      {
        label: '',
        data: [],
        backgroundColor: [],
      },
    ],
  },
  options: {
    responsive: true,
    legend: {
      position: 'bottom',
      display: true,
    },
  },
}
